<template>
  <div id="page-wrap">
    <div class="container-fluid">
      <div class="container">
        <div class="content-wrapper">
          <div class="content" v-if="!isApplySuccess">
            <ul>
              <li class="active">临时账号申请</li>
              <li @click="goToDelay">临时账号延期</li>
            </ul>
            <div class="content-header">
              <img src="@/assets/images/apply_header.png"  alt="">
              <div class="content-header_item item_1">
                <div class="content-header_item_title">1.填写临时账号申请表</div>
                <div class="content-header_item_content">填写个人、导师/校内朕系人信息、申请原因说明</div>
              </div>
              <div class="content-header_item item_2">
                <div class="content-header_item_title">2.导师/校内联系人审批</div>
                <div class="content-header_item_content">通过校内邮箱登陆审批</div>
              </div>
              <div class="content-header_item item_3">
                <div class="content-header_item_title">3.管理员开通临时账号</div>
                <div class="content-header_item_content">发送账号信息至用户邮箱</div>
              </div>
              <div class="content-header_item item_4">
                <div class="content-header_item_title">4.开通成功</div>
                <div class="content-header_item_content">申请人通过邮箱获取临时账号、密码</div>
              </div>
            </div>
            <div class="form apply-form">
              <div class="form-group">
                <div class="radiobox">
                  <div class="radio i-checks">
                    <label>
                      类型：
                    </label>
                  </div>
                  <div class="radio i-checks">
                    <label>
                      <input
                        name="account_type"
                        type="radio"
                        v-model="form.account_type"
                        value="1"
                        @change="handleChangeAccountType"
                      />
                      <i></i>
                      准研究生用户
                    </label>
                  </div>
                  <div class="radio i-checks">
                    <label>
                      <input
                        name="account_type"
                        type="radio"
                        v-model="form.account_type"
                        value="2"
                        @change="handleChangeAccountType"
                      />
                      <i></i>
                      校外合作用户
                    </label>
                  </div>
                </div>
                <span class="help-block" v-show="errors.has('account_type')">{{
                  errors.first("account_type")
                }}</span>
              </div>

              <div class="form-group">
                <input
                  class="form-control"
                  placeholder="申请人姓名"
                  type="text"
                  v-model.trim="form.name"
                  name="name"
                  data-vv-as="申请人姓名"
                  v-validate="{ required: true, min: 1, max: 100 }"
                />
                <span class="help-block" v-show="errors.has('name')">{{
                  errors.first("name")
                }}</span>
              </div>

              <div class="form-group form-text">
                <input
                  class="form-control"
                  placeholder="申请人邮箱"
                  type="text"
                  v-model.trim="form.email"
                  name="email"
                  data-vv-as="申请人邮箱"
                  v-validate="{ required: true, email: true }"
                />
                <span class="help-block" v-show="errors.has('email')">{{
                  errors.first("email")
                }}</span>
                <p class="text-msg" style="padding-top: 5px;">临时账号开通后，临时账号的账号和密码将发送至申请人邮箱</p>
              </div>

              <div class="form-group">
                <input
                  class="form-control"
                  placeholder="手机号"
                  type="text"
                  v-model.trim="form.mobile"
                  name="mobile"
                  data-vv-as="手机号"
                  v-validate="{ required: true, regex: /^1\d{10}$/ }"
                />
                <span class="help-block" v-show="errors.has('mobile')">{{
                  errors.first("mobile")
                }}</span>
              </div>

              <div class="form-group">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="验证码"
                    v-model.trim="form.sms_code"
                    name="sms_code"
                    data-vv-as="验证码 "
                    v-validate="{ required: true, min: 4, max: 8 }"
                  />
                  <span class="input-group-btn">
                    <button
                      class="btn btn-link"
                      type="button"
                      :disabled="smsSending || isSmsSendingRemainimg"
                      @click="sendMobileCodeFromApply"
                    >
                      {{ isSmsSendingRemainimg ? '剩余 ' + smsSendingRemainimgTime + ' 秒' : '发送验证码' }}
                    </button>
                  </span>
                </div>
                <span class="help-block" v-show="errors.has('sms_code')">{{
                  errors.first("sms_code")
                }}</span>
              </div>
              
              <div class="form-group" v-if="form.account_type=='1'" key="start_year">
                <div class="input-group" @click="getFormatDateFocus">
                  <input
                    class="form-control"
                    placeholder="入学年份"
                    type="text"
                    v-model.trim="form.start_year"
                    name="start_year"
                    data-vv-as="入学年份"
                    v-validate="{ required: true, date_format:'yyyy' }"
                  />
                  <div class="input-group-addon">
                    <i class="ti-calendar"></i>
                  </div>
                </div>
                <span class="help-block" v-show="errors.has('start_year')">{{
                  errors.first("start_year")
                }}</span>
              </div>
              
              <div class="form-group" v-if="form.account_type=='2'" key="department">
                <input
                  class="form-control"
                  placeholder="所属单位"
                  type="text"
                  v-model.trim="form.department"
                  name="department"
                  data-vv-as="所属单位"
                  v-validate="{ required: true, min: 1, max: 100 }"
                />
                <span class="help-block" v-show="errors.has('department')">{{
                  errors.first("department")
                }}</span>
              </div>

              <div class="form-group">
                <div class="radiobox">
                  <div class="radio i-checks">
                    <label>
                      有效期：
                    </label>
                  </div>
                  <div class="radio i-checks">
                    <label>
                      <input
                        name="valid_month"
                        type="radio"
                        v-model="form.valid_month"
                        value="3"
                      />
                      <i></i>
                      3个月
                    </label>
                  </div>
                  <div class="radio i-checks">
                    <label>
                      <input
                        name="valid_month"
                        type="radio"
                        v-model="form.valid_month"
                        value="6"
                      />
                      <i></i>
                      6个月
                    </label>
                  </div>
                  <div class="radio i-checks">
                    <label>
                      <input
                        name="valid_month"
                        type="radio"
                        v-model="form.valid_month"
                        value="9"
                      />
                      <i></i>
                      9个月
                    </label>
                  </div>
                  <div class="radio i-checks">
                    <label>
                      <input
                        name="valid_month"
                        type="radio"
                        v-model="form.valid_month"
                        value="12"
                      />
                      <i></i>
                      12个月
                    </label>
                  </div>
                </div>
                <span class="help-block" v-show="errors.has('valid_month')">{{
                  errors.first("valid_month")
                }}</span>
              </div>
              
              <div class="form-group">
                <input
                  class="form-control"
                  :placeholder="form.account_type==1 ? '导师姓名' : '联系人'"
                  type="text"
                  v-model.trim="form.link_name"
                  name="link_name"
                  :data-vv-as="form.account_type==1 ? '导师姓名' : '联系人'"
                  v-validate="{ required: true, min: 1, max: 100 }"
                />
                <span class="help-block" v-show="errors.has('link_name')">{{
                  errors.first("link_name")
                }}</span>
              </div>
              
              <div class="form-group form-text">
                <div class="input-group">
                  <input
                    class="form-control"
                    :placeholder="form.account_type==1 ? '导师邮箱' : '联系人邮箱'"
                    type="text"
                    v-model.trim="form.link_email"
                    name="link_email"
                    :data-vv-as="form.account_type==1 ? '导师邮箱' : '联系人邮箱'"
                    v-validate="{ required: true, email_prefix: true }"
                  />
                  <span class="input-group-btn">
                    <button
                      class="btn btn-link"
                      type="button"
                      style="cursor:auto;"
                    >
                      @ustc.edu.cn
                    </button>
                  </span>
                </div>
                <span class="help-block" v-show="errors.has('link_email')">{{
                  errors.first("link_email")
                }}</span>
                <p class="text-msg">临时账号申请后，申请信息将邮件发送至{{ form.account_type==1 ? '导师邮箱' : '联系人邮箱' }}邮箱</p>
              </div>

              <div class="form-group">
                <textarea
                  class="form-control"
                  placeholder="申请原因"
                  style="resize: vertical"
                  rows="4"
                  v-model.trim="form.desc"
                  name="desc"
                  data-vv-as="申请原因 "
                  v-validate="{ required: true, max: 255 }"
                ></textarea>
                <span class="help-block custom-help-block-1" v-show="errors.has('desc')">{{
                  errors.first("desc")
                }}</span>
              </div>

              <div class="form-group" key="file" v-if="form.account_type==1">
                <div class="preview" v-for="(item, index) in previewImages" :key=index>
                  <img
                    :src="item.image"
                    style="width: 60px; height: 60px;vertical-align: unset;padding: 2px;"
                  />
                </div>
                <div class="preview" style="cursor: pointer;" @click="handleUploadImage" v-if="!previewImages.length">
                  <input
                    ref="uploadImage"
                    class="filebtn"
                    :value="uploadValue"
                    type="file"
                    accept="image/jpeg, image/png"
                    name="image"
                    @change="setImage"
                  />
                </div>
                <span class="help-block custom-help-block-2" v-show="errors.has('file')">{{
                  errors.first("file")
                }}</span>
                <p class="text-msg">上传录取通知书，仅支持jpeg和png图片格式</p>
              </div>

              <div class="form-group">
                <button
                  class="btn btn-primary btn-submit"
                  type="button"
                  :disabled="loading"
                  @click="applyTempAccount"
                >
                  <span>{{ loading ? "正在提交..." : "提交" }}</span>
                </button>
              </div>
            </div>
          </div>
          <div class="success" v-else>
            <img src="@/assets/images/success.svg" />
            <p class="success-title">临时账号申请已提交</p>
            <p class="success-content">在您提交临时账号申请后，我们将向您提供的{{ form.account_type==1 ? '导师邮箱' : '联系人邮箱' }}发送一封审核邮件。您可以与您的{{ form.account_type==1 ? '导师' : '联系人' }}取得联系，以便他们进行审核。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { applyTempAccount, sendMobileCodeFromApply } from "@/api/user/user";
export default {
  name: "ApplyTempAccount",
  data() {
    return {
      isApplySuccess: false,
      uploadValue: "",
      loading: false,
      smsSending: false,
      isSmsSendingRemainimg: false,
      smsSendingRemainimgTime: 60,
      previewImages: [],
      form: {
        account_type: "1", // 类型
        name: '', // 姓名
        email: "", // 邮箱
        mobile: "", // 手机号
        sms_code: "", // 验证码
        desc: "", // 申请原因
        link_name: "", // 导师姓名 / 联系人姓名
        link_email: "", // 导师邮箱 / 联系人邮箱
        start_year: "", // 入学年份
        valid_month: '3', // 有效期
        department: '', // 所属单位
      }
    }
  },
  created() {
    this.$store.commit("SET_THEME", "临时账号申请");
  },
  methods: {
    getFormatDateFocus(event) {
      $(event.currentTarget)
        .find("input:first-child")
        .datetimepicker({
          format: "yyyy",
          weekStart: 1,
          autoclose: true,
          startView: 4,
          minView: 4,
          pickerPosition: "bottom-right",
          language: "zh-CN",
          startDate: new Date().getFullYear() - 8,
          endDate: new Date().getFullYear() + 1,
        })
        .datetimepicker("show")
        .on("changeDate", (ev) => {
          this.form.start_year = new Date(ev.date.valueOf()).getFullYear();
        })
        .on("hide", (ev) => {
          $(ev.currentTarget).datetimepicker("remove");
        });
    },
    goToDelay() {
      this.$router.push({name:'delayTempAccount'})
    },
    handleChangeAccountType() {
      this.$validator.reset();
      this.errors.remove("file")
      this.previewImages = []
    },
    // 发送短信验证码
    sendMobileCodeFromApply() {
      if (!this.form.mobile) {
        this.errors.add({
          field: "mobile",
          msg: "请填写手机号",
        });
        return false;
      }
      this.smsSending = true
      sendMobileCodeFromApply({
        mobile: this.form.mobile
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$message({
              type: "success",
              message: res.message,
            });

            // 发送成功后进入倒计时
            this.isSmsSendingRemainimg = true
            this.setEmailSendingRemainimgTime()
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        }).finally(() => {
          this.smsSending = false;
        });
    },
    // 验证码倒计时
    setEmailSendingRemainimgTime() {
      const timer = setInterval(() => {
        if (this.smsSendingRemainimgTime > 1) {
          this.smsSendingRemainimgTime--;
        } else {
          clearInterval(timer)
          this.isSmsSendingRemainimg = false
          this.smsSendingRemainimgTime = 60
        }
      }, 1000);
    },
    handleUploadImage() {
      this.$refs.uploadImage.click();
    },
    setImage(e) {
      this.uploadValue = "";
      const file = e.target.files[0];
      if (!file) {
        return;
      }
      // console.log(file.type)
      if (file.type!="image/jpeg" && file.type!="image/png") {
        this.$message({
          type: "warning",
          message: "图片格式仅支持jpeg和png",
        });
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.previewImages.push({
            image: event.target.result,
            file: file
          })
          this.errors.remove("file")
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    // 提交
    applyTempAccount() {
      if (this.form.account_type == 1 && !this.previewImages.length) {
        this.errors.add({
          field: "file",
          msg: "请上传图片",
        });
      }
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (this.form.account_type == 1 && !this.previewImages.length) {
            this.errors.add({
              field: "file",
              msg: "请上传图片",
            });
            return false;
          }
          this.loading = true;
          const formData = new FormData();
          formData.append("account_type", this.form.account_type);
          formData.append("name", this.form.name);
          formData.append("email", this.form.email);
          formData.append("mobile", this.form.mobile);
          formData.append("sms_code", this.form.sms_code);
          if (this.form.account_type == 1) {
            formData.append("start_year", this.form.start_year);
            
            this.previewImages.map(item => {
              formData.append("files[]", item.file)
            })
          } else if (this.form.account_type == 2) {
            formData.append("department", this.form.department);
          }
          formData.append("valid_month", this.form.valid_month);
          formData.append("link_name", this.form.link_name);
          formData.append("link_email", this.form.link_email + '@ustc.edu.cn');
          formData.append("desc", this.form.desc);
          applyTempAccount(formData)
            .then((res) => {
              if (res.status_code === 200) {
                this.isApplySuccess = true
                // this.form = {
                //   account_type: this.form.account_type, // 类型
                //   name: '', // 姓名
                //   email: "", // 邮箱
                //   mobile: "", // 手机号
                //   sms_code: "", // 验证码
                //   desc: "", // 申请原因
                //   link_name: "", // 导师姓名 / 联系人姓名
                //   link_email: "", // 导师邮箱 / 联系人邮箱
                //   start_year: "", // 入学年份
                //   valid_month: '3', // 有效期
                //   department: '', // 所属单位
                // }
                // if (this.form.account_type == 1) {
                //   this.previewImages = []
                // }
                // this.$message({
                //   type: "success",
                //   message: res.message,
                // });
                // this.$nextTick(() => {
                //   this.$validator.reset();
                // });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            }).finally(() => {
              this.loading = false;
              this.isSmsSendingRemainimg = false
              this.smsSendingRemainimgTime = 60
            });
        }
      });
    },
  }
};
</script>

<style scoped>
  .i-checks input[disabled]+i:before{
    background-color: #ddd;
  }
  .i-checks input[disabled]+i:before, fieldset[disabled] .i-checks input+i:before {
    color: #fff;
  }
  .i-checks input[disabled]+i, fieldset[disabled] .i-checks input+i {
    border-color: #ddd;
  }
  .i-checks input:checked+i:before {
    border-radius: 9px !important;
  }
  .i-checks input[type="radio"]+i {
    border-radius: 100% !important;
  }
  @media (max-width: 1200px) {
    .content-wrapper .content {
      background-size: 40% !important;
      background-position: 97% 50% !important;
    }
  }

  @media (max-width: 992px) {
    .content-wrapper .content .content-header {
      display: none !important;
    }
    .content-wrapper .content {
      background-image: unset !important;
    }
    .content-wrapper .content .form {
      margin-top: 20px;
      width: 100% !important;
    }
  }

  @media (max-width: 768px) {
    .content-wrapper .content {
      height: auto !important;
    }

    .help-block {
      height: auto !important;
      display: block !important;
      position: unset !important;
      top: unset;
      margin-left: 0 !important;
    }
    
    .custom-help-block-1 {
      top: unset;
    }
    .custom-help-block-2 {
      top: unset;
    }

    .content-wrapper .content .form .form-group>.input-group,
    .content-wrapper .content .form .form-group>.form-control,
    .content-wrapper .content .form .form-group .radiobox,
    .content-wrapper .content .form .form-group .btn-submit {
      margin-left: 0 !important;
      width: 100% !important;
    }
    .content-wrapper .content .form .form-group .input-group {
      display: block;
    }
    .content-wrapper .content .form .form-group .preview {
      margin-left: 0 !important;
    }
    .content-wrapper .content .form .form-group .form-control {
      display: block !important;
    }
    .form-group {
      position: unset !important;
    }
    .text-msg {
      margin-left: 0 !important;
    }
  }
  .content-wrapper .content {
    background: #fff;
    background-image: url(../../assets/images/apply_bg.png);
    background-size: 40%;
    background-position: 90% 50%;
    background-repeat: no-repeat;
    border: 1px solid #e1e1e1;
    height: 920px;
    padding: 0 20px;
  }
  .content-wrapper .content ul {
    display: flex;
    flex-direction: row;
    border-bottom: 2px solid #e1e1e1;
    padding: 30px 20px 20px 20px;
  }
  .content-wrapper .content ul li {
    list-style-type:none;
    margin-right: 20px;
    font-size: 18px;
    position: relative;
    color: #222;
  }
  .content-wrapper .content ul li:not(.active) {
    color: #999;
    cursor: pointer;
  }
  .content-wrapper .content ul li.active:after {
    position: absolute;
    left: 0;
    bottom: -23px;
    content: '';
    width: 100%;
    border-bottom: 4px solid #006adf;
  }
  .content-wrapper .content .content-header {
    width: calc(100% - 40px);
    margin: 20px auto;
    text-align: center;
    display: block;
    position: relative;
  }
  .content-wrapper .content .content-header img {
    width: 100%;
  }
  .content-wrapper .content .content-header .content-header_item {
    position: absolute;
    text-align: left;
    transform: scale(0.8);
    top: 6px;
  }
  .content-wrapper .content .content-header .item_1 {
    left: -12px;
  }
  .content-wrapper .content .content-header .item_2 {
    left: 300px;
  }
  .content-wrapper .content .content-header .item_3 {
    left: 560px;
  }
  .content-wrapper .content .content-header .item_4 {
    left: 810px;
  }
  .content-wrapper .content .content-header .content-header_item .content-header_item_title {
    font-weight: bold;
    font-size: 18px;
  }
  .content-wrapper .content .content-header .content-header_item .content-header_item_content {
    font-size: 14px;
  }
  .content-wrapper .content .form {
    width: 100%;
  }

  .content-wrapper .content .form .form-group>.input-group,
  .content-wrapper .content .form .form-group>.form-control,
  .content-wrapper .content .form .form-group .radiobox,
  .content-wrapper .content .form .form-group .btn-submit {
    margin-left: 60px;
    width: 400px;
  }
  .content-wrapper .content .form .form-group .input-group {
    display: inline-table;
  }
  .content-wrapper .content .form .form-group .preview {
    margin-left: 60px;
  }
  .content-wrapper .content .form .form-group .form-control {
    display: inline-block;
  }

  .form-group .btn-submit {
    width: 100%;
    outline: none !important;
  }

  .form-group .btn-link {
    outline: none !important;
  }

  .filebtn {
    display: none;
  }

  .apply-form .form-group .radiobox {
    margin:10px 0 10px 0;
    float:none;
  }

  .apply-form .form-group .radio {
    display: inline-block;
    margin-right: 12px;
  }

  .preview {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 60px;
    margin-right: 2px;
    border: #e1e1e1 solid 1px;
    /* padding: 1px; */
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAA8CAIAAAB+RarbAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo0OTZCNjVBODU3NjAxMUU5ODU1QkJEOTlGNUYxNDEzOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo0OTZCNjVBOTU3NjAxMUU5ODU1QkJEOTlGNUYxNDEzOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjQ5NkI2NUE2NTc2MDExRTk4NTVCQkQ5OUY1RjE0MTM5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjQ5NkI2NUE3NTc2MDExRTk4NTVCQkQ5OUY1RjE0MTM5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+6uHNWgAAAHdJREFUeNrs2bENwDAIAEE7w7ITLEsGSBoXlgvfb3BCiILZ3eOmnnFZwMDAwMDAwMDAwMDAwMDAwMDAwMA/VZUJAwMDAwN/m7u/h0sXKCK2i/tEmdmHssPAwMDAV99hEwYGBgYGBgYGBgYGBgYGBgYGBgZe6hVgAAJd/BePr1pNAAAAAElFTkSuQmCC) -10px 0px;
  }

  .success {
    background: #fff;
    border: 1px solid #e1e1e1;
    min-height: 500px;
    padding: 20px;
    font-size: 1.2em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
  }
  .success img {
    width: 100px;
  }
  .success .success-title {
    font-size: 1.4em;
    line-height: 2;
  }
  .success .success-content {
    font-size: 1.0em;
    line-height: 2;
    max-width: 800px;
  }
  .form-group {
    position: relative;
  }
  .help-block {
    height: 20px;
    display: unset;
    position: absolute;
    top: 3px;
    margin-left: 10px;
  }
  .custom-help-block-1 {
    top: 30px;
  }
  .custom-help-block-2 {
    top: 15px;
  }
  .text-msg {
    color: #999;
    margin-left: 60px;
  }
  .form-text {
    margin-bottom: 5px !important;
  }
</style>